// extracted by mini-css-extract-plugin
module.exports = {"container":"ShopPacks_container__1G1bq","tabs":"ShopPacks_tabs__2-THi","rotate":"ShopPacks_rotate__KWEYF"};